<template>
  <section class="index">
    <!-- 新闻中心/轮播图 -->
    <div class="section-a">
      <div class="width-a">
        <swiper ref="indexBannerSwiper" style="margin-top:40px" :options="indexBannerSwiperOptions">
          <template v-for="(item, index) in carouselData">
            <swiper-slide>
              <div class="img-a">
                <a :href="item.jumpUrl" target="_blank">
                  <img :src="item.imageUrl  | fileFilter" alt="" />
                </a>
              </div>
            </swiper-slide>
          </template>
          <!--
                    <swiper-slide>
                        <img style="width: 100%; height: 100%" src="@/assets/icona/iconb02.jpg" alt="" />
                    </swiper-slide>
                    <swiper-slide>
                        <img style="width: 100%; height: 100%" src="@/assets/icona/iconb03.jpg" alt="" />
                    </swiper-slide>
                    <swiper-slide>
                        <img style="width: 100%; height: 100%" src="@/assets/icona/iconb04.jpg" alt="" />
                    </swiper-slide>
                    <swiper-slide>
                        <img style="width: 100%; height: 100%" src="@/assets/icona/iconb05.jpg" alt="" />
                    </swiper-slide>
                    -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <h2 class="title">新闻中心</h2>
        <div class="news">
          <div class="news-a">
            <div class="cover">
              <img :src="newsData[0].imageUrl | fileFilter" alt="">
            </div>
            <div class="desc">
              <h3 class="name">{{newsData[0].newsTitle}}</h3>
              <div class="time">
                <span>{{newsData[0].publishTime}}</span>
                <span style="cursor: pointer" @click="detailNews(0)">详情 +</span>
              </div>
            </div>
          </div>
          <div class="news-b">
            <div class="item">
              <div class="name">
                <div class="cover">
                  <img src="@/assets/icona01.png" alt="">
                </div>
                <h3>{{newsData[1].newsTitle}}</h3>
              </div>
              <div class="time">
                <span>{{newsData[1].publishTime}}</span>
                <span style="cursor: pointer" @click="detailNews(1)">详情 +</span>
              </div>
            </div>
            <div class="item">
              <div class="name">
                <div class="cover">
                  <img src="@/assets/icona01.png" alt="">
                </div>
                <h3>{{newsData[2].newsTitle}}</h3>
              </div>
              <div class="time">
                <span>{{newsData[2].publishTime}}</span>
                <span style="cursor: pointer" @click="detailNews(2)">详情 +</span>
              </div>
            </div>
            <div class="item">
              <div class="name">
                <div class="cover">
                  <img src="@/assets/icona01.png" alt="">
                </div>
                <h3>{{newsData[3].newsTitle}}</h3>
              </div>
              <div class="time">
                <span>{{newsData[3].publishTime}}</span>
                <span style="cursor: pointer" @click="detailNews(3)">详情 +</span>
              </div>
            </div>
            <div class="more-news" @click="moreNews">查看更多</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公开资源 -->
    <div class="section-b">
      <div class="width-a">
        <div class="title-b">
          <h2 class="title-c">公开资源</h2>
          <span class="title-d" @click="moreResource">更多 ></span>
        </div>
        <div class="courses">
          <template v-for="(item, index) in resourceData">
            <div class="course" v-bind:key="item.resourceId" @click="detailResource(index)">
              <div class="cover">
                <img :src="item.imgUrl | fileFilter" alt="">
              </div>
              <div class="info-a">
                <h3 class="name">{{item.resourceName}}</h3>
                <p class="txt-a">{{item.introduce}}</p>
                <div class="info">
                  <span>{{item.clickCount}}人观看</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>这是一段信息</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 师资阵容 -->
    <div class="section-c">
      <div class="width-a">
        <div class="title-b">
          <h2 class="title-c">师资阵容</h2>
          <span class="title-d" @click="moreTeacher">更多 ></span>
        </div>
        <div class="teachers frcs">
          <template v-for="(item, index) in teacherData">
            <div class="teacher" :key="item.userId" @click="detailTeacher(index)">
              <div class="cover">
                <img :src="item.avatar | fileFilter" alt="">
              </div>
              <div class="info fccc">
                <p class="txt-ta">{{item.nickName}}</p>
                <p class="txt-tb">{{item.teacherTitle}}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 精英采访模块 -->

    <div class="section-b">
      <div class="width-a">
        <div class="title-b">
          <h2 class="title-c">精英采访</h2>
          <span class="title-d" @click="moreInterviews">更多 ></span>
        </div>
        <div class="students">
          <div>
            <div class="item-a" @click="detailInterviews(0)">
              <div class="cover">
                <img :src="interviewData[0].imgUrl | fileFilter" alt="">
              </div>
              <div class="info info-a">
                <p class="txt-a">{{interviewData[0].introduce}}</p>
                <div class="txt-b">- {{interviewData[0].interviewTitle}}</div>
              </div>
            </div>
            <div class="item-a" @click="detailInterviews(1)">
              <div class="info info-b">
                <p class="txt-a">{{interviewData[1].introduce}}</p>
                <div class="txt-b">- {{interviewData[1].interviewTitle}}</div>
              </div>
              <div class="cover">
                <img :src="interviewData[1].imgUrl | fileFilter" alt="">
              </div>
            </div>
          </div>
          <div class="item-b" @click="detailInterviews(2)">
            <div class="cover">
              <img :src="interviewData[2].imgUrl | fileFilter" alt="">
            </div>
            <div class="info info-c">
              <p class="txt-a">{{interviewData[2].introduce}}</p>
              <div class="txt-b">- {{interviewData[2].interviewTitle}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-c">
      <div class="width-a">
        <div v-for="(item, index) in customize" :key="index" class="customize">
          <h2 class="title-z">{{item.title}}</h2>
          <span class="more-z" @click="moreCustomize(item.typeId)">更多 ></span>
          <div class="news">
            <div class="news-c">
              <div class="item" v-for="(_item,_index) in item.list" :key="_index">
                <div class="name">
                  <div class="cover">
                    <img src="@/assets/icona01.png" alt="">
                  </div>
                  <h3>{{_item.customizeTitle}}</h3>
                </div>
                <div class="time">
                  <span>{{_item.publishTime}}</span>
                  <span style="cursor: pointer" @click="detailCustomize(_item.customizeId)">详情 +</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Auth from "@/utils/Auth";
import HttpConnectionC from "@/utils/HttpConnectionC";
import CommonFilters from "@/mixins/CommonFilters";
export default {
  name: "Index",
  components: {},
  mixins: [CommonFilters],
  data () {
    return {
      indexBannerSwiperOptions: {
        loop: true,
        autoplay: {
            delay: 3000
        },
        pagination: {
          el: ".swiper-pagination"
        }
      },
      dialogVisible: false,
      carouselData: [], // 轮播图
      newsData: [
        {
          newsTitle: "",
          imageUrl: ""
        },
        {
          newsTitle: "",
          imageUrl: ""
        },
        {
          newsTitle: "",
          imageUrl: ""
        },
        {
          newsTitle: "",
          imageUrl: ""
        }
      ],
      interviewData: [ // 精英采访
        {
          imgUrl: "",
          introduce: "",
          interviewTitle: ""
        },
        {
          imgUrl: "",
          introduce: "",
          interviewTitle: ""
        },
        {
          imgUrl: "",
          introduce: "",
          interviewTitle: ""
        },
        {
          imgUrl: "",
          introduce: "",
          interviewTitle: ""
        }
      ],
      teacherData: [], // 师资阵容
      resourceData: [], // 公开资源
      customize: [] // 自定义数据
    };
  },
  mounted () {
    this.initIndex();
  },
  methods: {
    initIndex () {
      let that = this;
      HttpConnectionC.get("/homepage/list").then(function (response) {
        that.carouselData = response.data.carouselData;
        that.newsData = response.data.newsData;
        that.interviewData = response.data.interviewData;
        that.teacherData = response.data.teacherData;
        that.resourceData = response.data.resourceData;
        for (let key in response.data.customizeData) {
          that.customize.push({ title: key, typeId: response.data.customizeData[key][0].typeId, list: response.data.customizeData[key] })
        }
      });
    },
    moreNews () {
      this.$router.push({
        path: "/News"
      });
    },
    detailNews (index) {
      let _id = this.newsData[index].newsId;
      this.$router.push({
        path: "/NewsDetail?newsId=" + _id
      });
    },
    detailCustomize (id) {
      this.$router.push({
        path: "/CustomizeDetail?customizeId=" + id
      });
    },
    moreInterviews () {
      this.$router.push({
        path: "/Interviews"
      });
    },
    moreCustomize (typeId) {
      this.$router.push({
        path: "/Customize?typeId=" + typeId
      });
    },
    detailInterviews (index) {
      let _id = this.interviewData[index].interviewId;
      this.$router.push({
        path: "/InterviewsDetail?interviewId=" + _id
      });
    },
    moreTeacher () {
      this.$router.push({
        path: "/Teachers"
      });
    },
    detailTeacher (index) {
      let _id = this.teacherData[index].userId;
      this.$router.push({
        path: "/TeacherDetail?userId=" + _id
      });
    },
    moreResource () {
      this.$router.push({
        path: "/OpenResource"
      });
    },
    detailResource (index) {
      if (Auth.getToken()) {
        let _id = this.resourceData[index].resourceId;
        this.$router.push({
          path: "/OpenResourceDetail?resourceData=" + _id
        });
      } else {
        this.$store.commit("setShowLogin", true);
      }
    },
    carouselDataTap (index) {
      let _path = this.carouselData[index].jumpUrl;
      window.open(_path, "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
.section-a {
  padding: 0px 0px 32px 0px;
  background-color: #ffffff;
}

.section-b {
  background-color: #f7f8fa;
  padding: 56px 0px;
}

.section-c {
  background-color: #ffffff;
  padding: 56px 0px;
}

.customize {
  margin-bottom: 40px;
}

.title-z {
  color: #333333;
  font-size: 30px;
  font-weight: normal;
  display: inline-block;
}

.more-z {
  font-size: 16px;
  color: #666666;
  cursor: pointer;
  float: right;
  margin-top: 10px;
}

.banner {
  width: 1480px;
  height: 464px;
  background-color: #bababa;
  border-radius: 8px;
}

.title {
  color: #333333;
  font-size: 30px;
  font-weight: normal;
  margin: 55px 0px 32px 0px;
}

.title-b {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0px 32px 0px;
}

.title-c {
  color: #333333;
  font-size: 30px;
  font-weight: normal;
}

.title-d {
  font-size: 16px;
  color: #666666;
  cursor: pointer;
}

.news {
  display: flex;
  flex-direction: row;
}

.news-a {
  width: 420px;
  height: 419px;
  box-shadow: 0px 8px 16px 0px #f7f8fa;
  border-radius: 8px;

  .cover {
    width: 420px;
    height: 250px;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: center;
    align-content: center;

    img {
      margin: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .desc {
    width: 420px;
    padding: 26px 26px 26px 26px;
  }

  .name {
    width: 370px;
    height: 80px;
    font-size: 18px;
    color: #333333;
    font-weight: normal;
  }

  .time {
    width: 370px;
    padding: 16px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #e3e4e6;
    font-size: 16px;
    color: #999999;
  }
}

.news-b {
  margin: 0px 0px 0px 60px;

  .item {
    width: 700px;
    padding: 16px 0px 24px 0px;
    border-bottom: 1px solid #e3e4e6;

    .name {
      height: 56px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .cover {
        width: 24px;
        height: 24px;
        margin: 0px 16px 0px 0px;
        display: flex;
        justify-content: center;
        align-content: center;

        img {
          margin: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      h3 {
        font-size: 18px;
        color: #333333;
        font-weight: normal;
      }
    }

    .time {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #999999;
    }
  }

  .more-news {
    width: 120px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 28px;
    border: solid 1px #333333;
    margin-top: 24px;
    cursor: pointer;
  }
}

.news-c {
  width: 100%;

  .item {
    width: 100%;
    padding: 16px 0px 24px 0px;
    border-bottom: 1px solid #e3e4e6;

    .name {
      height: 56px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .cover {
        width: 24px;
        height: 24px;
        margin: 0px 16px 0px 0px;
        display: flex;
        justify-content: center;
        align-content: center;

        img {
          margin: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      h3 {
        font-size: 18px;
        color: #333333;
        font-weight: normal;
      }
    }

    .time {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #999999;
    }
  }

  .more-news {
    width: 120px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 28px;
    border: solid 1px #333333;
    margin-top: 24px;
    cursor: pointer;
  }
}

.courses {
  display: grid;
  grid-row-gap: 40px;
  grid-column-gap: 35px;
  grid-template-columns: repeat(2, 570px);
}

.course {
  width: 570px;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;

  .cover {
    width: 224px;
    height: 160px;
    display: flex;
    justify-content: center;
    align-content: center;

    img {
      margin: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .name {
    font-size: 16px;
    color: #333333;
  }

  .txt-a {
    font-size: 14px;
    color: #999999;
    height: 96px;
  }

  .info-a {
    width: 432px;
    margin: 0px 0px 0px 20px;

    .txt-a {
      font-size: 14px;
      color: #999999;
      height: 96px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
  }

  .info {
    height: 36px;
    line-height: 36px;
    border-top: 1px solid #f2f3f5;
    color: #999999;
    font-size: 16px;
  }
}

.teacher {
  border-radius: 8px;
  border: solid 1px #e8e9eb;

  .cover {
    width: 270px;
    height: 276px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 10px;

    img {
      margin: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .info {
    width: 270px;
    height: 104px;
    background-color: #ffffff;
    font-size: 14px;
  }

  .txt-ta {
    font-size: 20px;
    color: #333333;
  }

  .txt-tb {
    font-size: 16px;
    color: #666666;
    margin: 16px 0px 0px 0px;
  }
}

.students {
  display: flex;
  flex-direction: row;

  .item-a {
    display: flex;
    flex-direction: row;
  }

  .cover {
    width: 393px;
    height: 246px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: #fff;

    img {
      margin: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .info {
    width: 393px;
    height: 246px;
    padding: 40px 32px;
    background-color: #ffffff;
    position: relative;

    .txt-a {
      font-size: 16px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
    }

    .txt-b {
      font-size: 20px;
      height: 32px;
      color: #333333;
      text-align: right;
      margin: 30px 0px 0px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
    }
  }

  .info-a:before {
    content: "";
    border-width: 12px;
    border-style: dashed solid dashed dashed;
    border-color: transparent #ffffff transparent transparent;
    position: absolute;
    left: -24px;
    top: 148px;
  }

  .info-b:before {
    content: "";
    border-width: 12px;
    border-style: dashed dashed dashed solid;
    border-color: transparent transparent transparent #ffffff;
    position: absolute;
    right: -24px;
    top: 148px;
  }

  .info-c:before {
    content: "";
    border-width: 12px;
    border-style: dashed dashed solid dashed;
    border-color: transparent transparent #ffffff transparent;
    position: absolute;
    right: 220px;
    top: -24px;
  }
}

.img-a {
  width: 1180px;
  height: 420px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>